import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";

function PlanPeriodCard({ femaleCycleDays, dayKey }) {
  const { t } = useTranslation("athlete-portal");
  if (!femaleCycleDays || femaleCycleDays.length === 0) return null;
  const entry = femaleCycleDays.find((d) => d.date === dayKey);
  if (!entry) return null;
  const dayNum = entry.day || entry.cycleDay || entry.dayNumber;
  const label =
    entry.type === "predicted"
      ? t("calendar.cards.period.predicted")
      : t("calendar.cards.period.actual");
  return (
    <div
      className={`plan-card ${entry.type === "predicted" ? "plan-card--period-predicted" : "plan-card--period"}`}
    >
      <div className="plan-card__header">
        <SvgIcon
          src="/img/new-icons/blood-drop-icon.svg"
          noFilterOnLight={true}
        />
        {dayNum
          ? t("calendar.cards.period.dayLabel", { day: dayNum, label })
          : label}
      </div>
    </div>
  );
}

export default PlanPeriodCard;
